import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  scrolled?: boolean;
}

const Logo: React.FC<LogoProps> = ({ scrolled = false }) => {
  return (
    <Link to="/" className="flex items-center">
      <img
        src="https://www.acsecapital.com/acse-capital-inc-email.png"
        alt="ACSE Capital Logo"
        className={`h-16 object-contain transition-all duration-300 ${
          scrolled ? 'brightness-90 scale-90' : 'brightness-100'
        }`}
      />
    </Link>
  );
};

export default Logo;